import * as React from 'react';
import {Button, Stack} from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import {secured as axios} from '../../axios';
import {useNavigate} from 'react-router-dom';
import {useEffect, useState} from 'react';
import {useLocation} from 'react-router-dom';
import {useDarkMode} from '../darkMode/hook/useDarkMode';
import {usePoliceMode} from '../policeMode/hook/usePoliceMode';

const SearchBar = ({setSearchResponse, setSearchInput}) => {
  console.log(setSearchInput);
  const myParam = useLocation().search;
  const searchInput = new URLSearchParams(myParam).get('query');
  const [value, setValue] = useState('');
  useEffect(() => {
    if (searchInput !== '') {
      setValue(searchInput);
    }
  }, []);
  const {mode} = useDarkMode();

  const validateData = input => {
    return input !== '';
  };
  const navigate = useNavigate();
  const handleSubmit = event => {
    event.preventDefault();
    const data = new FormData(event.currentTarget);
    const input = data.get('searchInput');
    if (validateData(input)) {
      navigate(`/search?query=${input}`);
    }
  };
  const {police} = usePoliceMode();
  return (
    <form id={'searchInputContainer'} onSubmit={handleSubmit}>
      <Stack
        sx={{
          flexGrow: 1,
          justifyContent: 'center',
        }}
        direction={'row'}>
        <input
          aria-label={'Champ de recherche'}
          title={'contenu'}
          id={'searchInput'}
          name={'searchInput'}
          style={{
            height: 47,
            backgroundColor: mode.settings.card2BackgroundColor,
            color: mode.settings.textColor9,
            paddingLeft: 15,
            fontFamily: police.normalMode ? 'Roboto' : 'Comic Sans MS',
            flexGrow: 1,
            fontSize: 14,
            maxWidth: 350,
          }}
          value={value}
          onChange={event => setValue(event.target.value)}
          placeholder="Recherchez un service, un conseil…"
        />
        <Button
          id="buttonSearch"
          endIcon={
            <SearchIcon role={'img'} aria-label={'search-button'} size={20} />
          }
          type="submit"></Button>
      </Stack>
    </form>
  );
};

export default SearchBar;
